import { render } from "./NumberSetting.vue?vue&type=template&id=2c7e75d4&scoped=true&ts=true"
import script from "./NumberSetting.vue?vue&type=script&lang=ts"
export * from "./NumberSetting.vue?vue&type=script&lang=ts"

import "./NumberSetting.vue?vue&type=style&index=0&id=2c7e75d4&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7e75d4"]])

export default __exports__